import { toCurrencySymbol } from '@/utils/money.utils';
import links from "@/constants/links";

/**
 * Get formatted price
 * @param {string} currency
 * @param {string} price
 */
export const toPrice = (currency, price) => `${toCurrencySymbol(currency)} ${price}`;

/**
 * Get formatted order id
 * @param {string} id
 */
export const toOrderId = (id) => `# ${id}`;

/**
 * Get status phrase
 * @param {object} statuses
 * @param {string} statusId
 */
export const toStatus = (statuses, statusId) => statuses[statusId];

/**
 * Format transactions the right way
 * @param {object} statuses
 * @param {string} currency
 * @param {object} orders
 */
export const toTransactions = (statuses, currency, orders) => orders.map((order) => ({
    orderId: toOrderId(order.id),
    transactionId: order.txn_id,
    price: toPrice(currency, order.amount),
    points: order.points,
    provider: order.provider_name,
    status: toStatus(statuses, order.status),
    created: order.created_at,
    hasInvoice: (order.invoicePath != "") ? 1 : 0,
    pdfLink: order.invoicePath ?
        links.endpoints.fileDownload.replace('{fileName}', order.invoicePath) : ""
}));

/**
 * Get all headers for transactions list
 */
export const getHeaders = () => [{
        text: 'Order Id',
        align: 'left',
        sortable: true,
        value: 'orderId'
    },
    {
        text: 'Transaction Id',
        align: 'left',
        sortable: true,
        value: 'transactionId'
    },
    {
        text: 'Price',
        align: 'left',
        sortable: true,
        value: 'price'
    },
    {
        text: 'Points',
        align: 'left',
        sortable: true,
        value: 'points'
    },
    {
        text: 'Provider',
        align: 'left',
        sortable: true,
        value: 'provider'
    },
    {
        text: 'Status',
        align: 'left',
        sortable: true,
        value: 'status'
    },
    {
        text: 'Created',
        align: 'left',
        sortable: true,
        value: 'created'
    },
    {
        text: 'Invoice',
        align: 'left',
        sortable: true,
        value: 'pdfLink'
    },
]
